require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./crucibles-of-mystery.json") })
        }
      }, "path---crucibles-of-mystery");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---crucibles-of-mystery!./.cache/json/crucibles-of-mystery.json
// module id = 836
// module chunks = 231608221292675